<template>
  <div class="virtual-category">
    <CategoryInput
      v-if="view === 'modal'"
      :show-placeholder="true"
      :value="value"
      @click="show = true"
      class="elder-input__element"
    />
    <Render
      v-if="show || view === 'default'"
      :view="view"
      :value="value"
      @input="$ev => $emit('input', $ev)"
      @close="show = false"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
// import Modal from './Modal'
import Render from './Render'
import CategoryInput from './Input'

export default {
  props: {
    value: String,
    seperator: {
      type: String,
      default: '/',
    },
    mode: {
      type: String,
      enum: ['select-only', 'default'],
      default: 'default',
    },
    view: {
      type: String,
      enums: ['modal', 'default'],
      default: 'modal',
    },
  },
  provide() {
    return {
      seperator: () => this.seperator,
      mode: () => this.mode,
    }
  },
  data() {
    return {
      show: false,
    }
  },
  components: {
    CategoryInput,
    Render,
  },
}
</script>

<style lang="scss"></style>
